import Vue from 'vue'
const checkType = value => Object.prototype.toString.call(value)
Vue.directive('format', {
  inserted(el, binding) {
    let value = binding.value
    if (!value) return
    if (checkType(value) !== '[object Number]') {
      value = value.split('/')
      el.innerText = Format(Math.ceil(value[0]), value[1])
      return
    }
    el.innerText = Format(value)
  },
  update(el, binding) {
    let value = binding.value
    if (!value) return
    if (checkType(value) !== '[object Number]') {
      value = value.split('/')
      el.innerText = Format(Math.ceil(value[0]), value[1])
      return
    }
    el.innerText = Format(value)
  }
})

function Format(timer, format = 'yyyy-MM-dd hh:mm:ss') {
  if (!timer) return ''
  timer = Math.ceil(timer)
  const d = new Date(timer)
  return d.Format(format)
}
